import { NavLink, useNavigate } from 'react-router-dom'
import type { ReactNode } from 'react'
import { useAuth } from './auth'
import { COMPANY_LABEL, ROLE_LABEL } from './api'

const NAV = [
  { to: '/', label: 'ダッシュボード', end: true },
  { to: '/customers', label: '顧客' },
  { to: '/contracts', label: '保守契約' },
  { to: '/reports', label: '対応履歴' },
  { to: '/alerts', label: '期限間近' },
]

export function Layout({ children }: { children: ReactNode }) {
  const { user, logout } = useAuth()
  const navigate = useNavigate()

  const handleLogout = async () => {
    await logout()
    navigate('/login', { replace: true })
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <div className="brand">
          <span className="brand-mark">P</span>
          <span>PROFE MAINT</span>
        </div>
        <nav>
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>
        <div className="user-menu">
          {user && (
            <>
              <span>
                {user.name}
                <span className="subtle">
                  {' '}
                  ／ {COMPANY_LABEL[user.company]} ／ {ROLE_LABEL[user.role]}
                </span>
              </span>
              <button
                type="button"
                className="btn btn-ghost btn-sm"
                onClick={handleLogout}
              >
                ログアウト
              </button>
            </>
          )}
        </div>
      </header>
      <main className="app-main">{children}</main>
    </div>
  )
}
